import { SVGProps, memo } from 'react';
const GenerateIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={props.width || '24'}
    height={props.height || '24'}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <g id='image icon'>
      <rect
        x='1'
        y='1'
        width='22'
        height='22'
        rx='6'
        stroke='black'
        strokeOpacity='0.56'
        strokeWidth='2'
      />
      <path
        id='Star 6'
        d='M9.41476 4.37869C9.46795 4.24342 9.65938 4.24342 9.71257 4.37869L11.0396 7.75359C11.0567 7.79699 11.0918 7.83079 11.1359 7.84613L14.6935 9.0853C14.8367 9.13516 14.8367 9.33763 14.6935 9.38749L11.1359 10.6267C11.0918 10.642 11.0567 10.6758 11.0396 10.7192L9.71257 14.0941C9.65938 14.2294 9.46795 14.2294 9.41476 14.0941L8.08773 10.7192C8.07066 10.6758 8.0355 10.642 7.99145 10.6267L4.4338 9.38749C4.29064 9.33763 4.29064 9.13516 4.4338 9.0853L7.99145 7.84613C8.0355 7.83079 8.07066 7.79699 8.08773 7.75359L9.41476 4.37869Z'
        fill='black'
        fillOpacity='0.56'
      />
      <path
        id='Star 7'
        d='M15.4515 11.364C15.5056 11.2311 15.6938 11.2311 15.7479 11.364L16.7606 13.8516C16.7781 13.8948 16.8136 13.9281 16.8578 13.9429L19.549 14.8484C19.6943 14.8973 19.6943 15.1028 19.549 15.1517L16.8578 16.0571C16.8136 16.0719 16.7781 16.1053 16.7606 16.1484L15.7479 18.636C15.6938 18.7689 15.5056 18.7689 15.4515 18.636L14.4389 16.1484C14.4213 16.1053 14.3858 16.0719 14.3417 16.0571L11.6505 15.1517C11.5052 15.1028 11.5052 14.8973 11.6505 14.8484L14.3417 13.9429C14.3858 13.9281 14.4213 13.8948 14.4389 13.8516L15.4515 11.364Z'
        fill='black'
        fillOpacity='0.56'
      />
    </g>
  </svg>
);

export default memo(GenerateIcon);
